// Maths snippets for the question editor's symbol palette.
// Each entry is [latex, description]; the description is what search matches on.
// Every snippet must render in KaTeX (admin preview and student site).

const mathSymbols = [
  {
    title: "Most used",
    symbols: [
      ["\\frac{a}{b}", "Fraction"],
      ["\\sqrt{x}", "Square root"],
      ["x^{2}", "Square / power"],
      ["x_{n}", "Subscript"],
      ["\\pm", "Plus or minus"],
      ["\\times", "Multiply (cross)"],
      ["\\div", "Divide"],
      ["\\cdot", "Dot / multiply"],
      ["\\neq", "Not equal"],
      ["\\leq", "Less than or equal"],
      ["\\geq", "Greater than or equal"],
      ["\\approx", "Approximately equal"],
      ["\\infty", "Infinity"],
      ["\\pi", "Pi"],
      ["\\theta", "Theta"],
      ["\\alpha", "Alpha"],
      ["\\beta", "Beta"],
      ["\\lambda", "Lambda"],
      ["\\omega", "Omega"],
      ["\\Delta", "Delta (change)"],
      ["\\int", "Integral"],
      ["\\int_{a}^{b}", "Definite integral"],
      ["\\sum_{i=1}^{n}", "Summation"],
      ["\\lim_{x \\to 0}", "Limit"],
      ["\\frac{dy}{dx}", "Derivative dy/dx"],
      ["\\sin", "Sine"],
      ["\\cos", "Cosine"],
      ["\\tan", "Tangent"],
      ["\\log", "Logarithm"],
      ["\\ln", "Natural log"],
      ["e^{x}", "Exponential e^x"],
      ["\\vec{a}", "Vector"],
      ["\\hat{i}", "Unit vector i"],
      ["\\hat{j}", "Unit vector j"],
      ["\\hat{k}", "Unit vector k"],
      ["^{\\circ}", "Degree"],
      ["\\angle", "Angle"],
      ["\\parallel", "Parallel"],
      ["\\perp", "Perpendicular"],
      ["\\in", "Element of"],
      ["\\cup", "Union"],
      ["\\cap", "Intersection"],
      ["\\Rightarrow", "Implies"],
      ["\\Leftrightarrow", "If and only if"],
      ["\\therefore", "Therefore"],
      ["\\because", "Because"],
    ],
  },
  {
    title: "Operators",
    symbols: [
      ["+", "Plus"],
      ["-", "Minus"],
      ["\\pm", "Plus or minus"],
      ["\\mp", "Minus or plus"],
      ["\\times", "Multiply (cross)"],
      ["\\div", "Divide"],
      ["\\cdot", "Dot / multiply"],
      ["/", "Slash"],
      ["\\ast", "Asterisk"],
      ["\\star", "Star"],
      ["\\circ", "Composition / ring"],
      ["\\bullet", "Bullet"],
      ["\\oplus", "Circled plus (XOR)"],
      ["\\ominus", "Circled minus"],
      ["\\otimes", "Circled times"],
      ["\\odot", "Circled dot"],
      ["\\%", "Percent"],
      ["n!", "Factorial"],
      ["\\wedge", "Wedge"],
      ["\\vee", "Vee"],
      ["\\setminus", "Set minus"],
      ["\\wr", "Wreath product"],
    ],
  },
  {
    title: "Fractions, powers & roots",
    symbols: [
      ["\\frac{a}{b}", "Fraction"],
      ["\\dfrac{a}{b}", "Large fraction"],
      ["\\tfrac{a}{b}", "Small fraction"],
      ["\\frac{1}{2}", "Half"],
      ["a/b", "Slash fraction"],
      ["\\cfrac{1}{1+\\cfrac{1}{x}}", "Continued fraction"],
      ["x^{2}", "Square"],
      ["x^{3}", "Cube"],
      ["x^{n}", "Power n"],
      ["x^{-1}", "Reciprocal"],
      ["x^{\\frac{1}{2}}", "Power one half"],
      ["x_{1}", "Subscript 1"],
      ["x_{n}", "Subscript n"],
      ["x_{i}^{2}", "Subscript and power"],
      ["a^{m} \\cdot a^{n} = a^{m+n}", "Law of indices (product)"],
      ["\\sqrt{x}", "Square root"],
      ["\\sqrt[3]{x}", "Cube root"],
      ["\\sqrt[n]{x}", "nth root"],
      ["\\sqrt{a^{2}+b^{2}}", "Root of sum of squares"],
      ["10^{n}", "Power of ten"],
      ["a \\times 10^{n}", "Scientific notation"],
    ],
  },
  {
    title: "Relations & comparison",
    symbols: [
      ["=", "Equals"],
      ["\\neq", "Not equal"],
      ["<", "Less than"],
      [">", "Greater than"],
      ["\\leq", "Less than or equal"],
      ["\\geq", "Greater than or equal"],
      ["\\nless", "Not less than"],
      ["\\ngtr", "Not greater than"],
      ["\\ll", "Much less than"],
      ["\\gg", "Much greater than"],
      ["\\approx", "Approximately equal"],
      ["\\simeq", "Similar or equal"],
      ["\\sim", "Similar / of order"],
      ["\\cong", "Congruent"],
      ["\\equiv", "Identical / congruent"],
      ["\\not\\equiv", "Not congruent"],
      ["\\propto", "Proportional to"],
      ["\\doteq", "Approaches the limit"],
      ["\\triangleq", "Defined as"],
      [":=", "Defined as (colon equals)"],
      ["\\prec", "Precedes"],
      ["\\succ", "Succeeds"],
      ["\\preceq", "Precedes or equal"],
      ["\\succeq", "Succeeds or equal"],
      ["\\mid", "Divides"],
      ["\\nmid", "Does not divide"],
      ["\\parallel", "Parallel"],
      ["\\nparallel", "Not parallel"],
      ["\\perp", "Perpendicular"],
      ["\\asymp", "Asymptotic"],
    ],
  },
  {
    title: "Greek letters",
    symbols: [
      ["\\alpha", "Alpha"],
      ["\\beta", "Beta"],
      ["\\gamma", "Gamma"],
      ["\\delta", "Delta"],
      ["\\epsilon", "Epsilon"],
      ["\\varepsilon", "Epsilon (variant)"],
      ["\\zeta", "Zeta"],
      ["\\eta", "Eta"],
      ["\\theta", "Theta"],
      ["\\vartheta", "Theta (variant)"],
      ["\\iota", "Iota"],
      ["\\kappa", "Kappa"],
      ["\\lambda", "Lambda"],
      ["\\mu", "Mu"],
      ["\\nu", "Nu"],
      ["\\xi", "Xi"],
      ["o", "Omicron"],
      ["\\pi", "Pi"],
      ["\\varpi", "Pi (variant)"],
      ["\\rho", "Rho"],
      ["\\varrho", "Rho (variant)"],
      ["\\sigma", "Sigma"],
      ["\\varsigma", "Sigma (final)"],
      ["\\tau", "Tau"],
      ["\\upsilon", "Upsilon"],
      ["\\phi", "Phi"],
      ["\\varphi", "Phi (variant)"],
      ["\\chi", "Chi"],
      ["\\psi", "Psi"],
      ["\\omega", "Omega"],
      ["\\Gamma", "Capital Gamma"],
      ["\\Delta", "Capital Delta"],
      ["\\Theta", "Capital Theta"],
      ["\\Lambda", "Capital Lambda"],
      ["\\Xi", "Capital Xi"],
      ["\\Pi", "Capital Pi"],
      ["\\Sigma", "Capital Sigma"],
      ["\\Upsilon", "Capital Upsilon"],
      ["\\Phi", "Capital Phi"],
      ["\\Psi", "Capital Psi"],
      ["\\Omega", "Capital Omega"],
      ["\\digamma", "Digamma"],
    ],
  },
  {
    title: "Trigonometry",
    symbols: [
      ["\\sin", "Sine"],
      ["\\cos", "Cosine"],
      ["\\tan", "Tangent"],
      ["\\cot", "Cotangent"],
      ["\\sec", "Secant"],
      ["\\csc", "Cosecant"],
      ["\\operatorname{cosec}", "Cosecant (cosec)"],
      ["\\sin\\theta", "Sine theta"],
      ["\\cos\\theta", "Cosine theta"],
      ["\\tan\\theta", "Tangent theta"],
      ["\\sin^{2}\\theta", "Sine squared"],
      ["\\cos^{2}\\theta", "Cosine squared"],
      ["\\tan^{2}\\theta", "Tangent squared"],
      ["\\sin^{-1}x", "Inverse sine"],
      ["\\cos^{-1}x", "Inverse cosine"],
      ["\\tan^{-1}x", "Inverse tangent"],
      ["\\cot^{-1}x", "Inverse cotangent"],
      ["\\sec^{-1}x", "Inverse secant"],
      ["\\operatorname{cosec}^{-1}x", "Inverse cosecant"],
      ["\\arcsin", "Arcsine"],
      ["\\arccos", "Arccosine"],
      ["\\arctan", "Arctangent"],
      ["\\sin^{2}\\theta + \\cos^{2}\\theta = 1", "Pythagorean identity"],
      ["1 + \\tan^{2}\\theta = \\sec^{2}\\theta", "Tan–sec identity"],
      ["\\sin 2\\theta = 2\\sin\\theta\\cos\\theta", "Double angle (sine)"],
      ["\\cos 2\\theta = \\cos^{2}\\theta - \\sin^{2}\\theta", "Double angle (cosine)"],
      ["\\sin(A \\pm B)", "Compound angle (sine)"],
      ["\\cos(A \\pm B)", "Compound angle (cosine)"],
      ["\\frac{a}{\\sin A} = \\frac{b}{\\sin B} = \\frac{c}{\\sin C}", "Sine rule"],
      ["c^{2} = a^{2} + b^{2} - 2ab\\cos C", "Cosine rule"],
      ["\\frac{\\pi}{2}", "Pi by 2 (90°)"],
      ["\\frac{\\pi}{3}", "Pi by 3 (60°)"],
      ["\\frac{\\pi}{4}", "Pi by 4 (45°)"],
      ["\\frac{\\pi}{6}", "Pi by 6 (30°)"],
      ["\\text{rad}", "Radian"],
    ],
  },
  {
    title: "Hyperbolic functions",
    symbols: [
      ["\\sinh", "Hyperbolic sine"],
      ["\\cosh", "Hyperbolic cosine"],
      ["\\tanh", "Hyperbolic tangent"],
      ["\\coth", "Hyperbolic cotangent"],
      ["\\operatorname{sech}", "Hyperbolic secant"],
      ["\\operatorname{csch}", "Hyperbolic cosecant"],
      ["\\sinh^{-1}x", "Inverse hyperbolic sine"],
      ["\\cosh^{-1}x", "Inverse hyperbolic cosine"],
      ["\\tanh^{-1}x", "Inverse hyperbolic tangent"],
    ],
  },
  {
    title: "Logarithms & exponentials",
    symbols: [
      ["\\log", "Logarithm"],
      ["\\log_{10}x", "Log base 10"],
      ["\\log_{2}x", "Log base 2"],
      ["\\log_{a}x", "Log base a"],
      ["\\ln", "Natural log"],
      ["\\ln x", "Natural log of x"],
      ["\\lg", "Log base 10 (lg)"],
      ["\\exp", "Exponential function"],
      ["e", "Euler's number"],
      ["e^{x}", "e to the x"],
      ["e^{-x}", "e to the minus x"],
      ["a^{x}", "a to the x"],
      ["\\log_{a}(mn) = \\log_{a}m + \\log_{a}n", "Log product rule"],
      ["\\log_{a}\\frac{m}{n} = \\log_{a}m - \\log_{a}n", "Log quotient rule"],
      ["\\log_{a}m^{n} = n\\log_{a}m", "Log power rule"],
      ["\\log_{a}b = \\frac{\\log b}{\\log a}", "Change of base"],
    ],
  },
  {
    title: "Limits & derivatives",
    symbols: [
      ["\\lim_{x \\to 0}", "Limit x to 0"],
      ["\\lim_{x \\to a}", "Limit x to a"],
      ["\\lim_{x \\to \\infty}", "Limit x to infinity"],
      ["\\lim_{x \\to a^{+}}", "Right-hand limit"],
      ["\\lim_{x \\to a^{-}}", "Left-hand limit"],
      ["\\lim_{n \\to \\infty}", "Limit n to infinity"],
      ["\\lim_{x \\to 0}\\frac{\\sin x}{x} = 1", "Standard limit sin x / x"],
      ["\\to", "Tends to"],
      ["\\frac{d}{dx}", "Derivative operator"],
      ["\\frac{dy}{dx}", "Derivative dy/dx"],
      ["\\frac{d^{2}y}{dx^{2}}", "Second derivative"],
      ["\\frac{d^{n}y}{dx^{n}}", "nth derivative"],
      ["f'(x)", "f prime"],
      ["f''(x)", "f double prime"],
      ["f^{(n)}(x)", "nth derivative of f"],
      ["y'", "y prime"],
      ["\\dot{x}", "Time derivative (dot)"],
      ["\\ddot{x}", "Second time derivative"],
      ["\\frac{\\partial f}{\\partial x}", "Partial derivative"],
      ["\\frac{\\partial^{2} f}{\\partial x^{2}}", "Second partial derivative"],
      ["\\partial", "Partial"],
      ["\\nabla", "Nabla / gradient"],
      ["\\nabla \\cdot \\vec{F}", "Divergence"],
      ["\\nabla \\times \\vec{F}", "Curl"],
      ["\\nabla^{2}", "Laplacian"],
      ["\\left.\\frac{dy}{dx}\\right|_{x=a}", "Derivative at a point"],
      ["\\frac{d}{dx}(uv) = u\\frac{dv}{dx} + v\\frac{du}{dx}", "Product rule"],
      ["\\frac{d}{dx}\\left(\\frac{u}{v}\\right) = \\frac{v\\frac{du}{dx} - u\\frac{dv}{dx}}{v^{2}}", "Quotient rule"],
      ["\\frac{dy}{dx} = \\frac{dy}{du}\\cdot\\frac{du}{dx}", "Chain rule"],
      ["dx", "Differential dx"],
      ["dy", "Differential dy"],
      ["\\Delta x", "Change in x"],
      ["\\delta x", "Small change in x"],
    ],
  },
  {
    title: "Integrals",
    symbols: [
      ["\\int", "Integral"],
      ["\\int f(x)\\,dx", "Indefinite integral"],
      ["\\int_{a}^{b} f(x)\\,dx", "Definite integral"],
      ["\\int_{0}^{\\infty}", "Integral 0 to infinity"],
      ["\\int_{-\\infty}^{\\infty}", "Integral over all reals"],
      ["\\int_{0}^{\\pi/2}", "Integral 0 to pi/2"],
      ["\\iint", "Double integral"],
      ["\\iiint", "Triple integral"],
      ["\\oint", "Closed (line) integral"],
      ["\\oiint", "Closed surface integral"],
      ["\\,dx", "dx (with space)"],
      ["+ C", "Constant of integration"],
      ["\\Big[ F(x) \\Big]_{a}^{b}", "Evaluate between limits"],
      ["\\int x^{n}\\,dx = \\frac{x^{n+1}}{n+1} + C", "Power rule"],
      ["\\int \\frac{1}{x}\\,dx = \\ln|x| + C", "Integral of 1/x"],
      ["\\int e^{x}\\,dx = e^{x} + C", "Integral of e^x"],
      ["\\int u\\,dv = uv - \\int v\\,du", "Integration by parts"],
      ["\\int_{a}^{b} f(x)\\,dx = \\int_{a}^{b} f(a+b-x)\\,dx", "King's property"],
    ],
  },
  {
    title: "Sums, products & series",
    symbols: [
      ["\\sum", "Sum"],
      ["\\sum_{i=1}^{n}", "Sum i = 1 to n"],
      ["\\sum_{r=0}^{n}", "Sum r = 0 to n"],
      ["\\sum_{n=1}^{\\infty}", "Infinite sum"],
      ["\\prod", "Product"],
      ["\\prod_{i=1}^{n}", "Product i = 1 to n"],
      ["\\coprod", "Coproduct"],
      ["\\bigcup_{i=1}^{n}", "Big union"],
      ["\\bigcap_{i=1}^{n}", "Big intersection"],
      ["a_{n}", "nth term"],
      ["T_{n}", "nth term (T)"],
      ["S_{n}", "Sum of n terms"],
      ["S_{\\infty}", "Sum to infinity"],
      ["a_{n} = a + (n-1)d", "AP nth term"],
      ["S_{n} = \\frac{n}{2}\\left[2a + (n-1)d\\right]", "AP sum"],
      ["a_{n} = ar^{n-1}", "GP nth term"],
      ["S_{n} = \\frac{a(r^{n}-1)}{r-1}", "GP sum"],
      ["S_{\\infty} = \\frac{a}{1-r}", "GP infinite sum"],
      ["\\sum_{r=1}^{n} r = \\frac{n(n+1)}{2}", "Sum of first n naturals"],
      ["\\sum_{r=1}^{n} r^{2} = \\frac{n(n+1)(2n+1)}{6}", "Sum of squares"],
      ["\\sum_{r=1}^{n} r^{3} = \\left[\\frac{n(n+1)}{2}\\right]^{2}", "Sum of cubes"],
      ["(a+b)^{n} = \\sum_{r=0}^{n} \\binom{n}{r} a^{n-r} b^{r}", "Binomial theorem"],
      ["T_{r+1} = \\binom{n}{r} a^{n-r} b^{r}", "General term (binomial)"],
      ["\\text{A.M.} \\geq \\text{G.M.} \\geq \\text{H.M.}", "AM–GM–HM inequality"],
    ],
  },
  {
    title: "Functions",
    symbols: [
      ["f(x)", "Function of x"],
      ["g(x)", "Function g"],
      ["f^{-1}(x)", "Inverse function"],
      ["(f \\circ g)(x)", "Composite function"],
      ["f: A \\to B", "Function from A to B"],
      ["x \\mapsto f(x)", "Maps to"],
      ["|x|", "Absolute value / modulus"],
      ["\\lfloor x \\rfloor", "Floor / greatest integer"],
      ["\\lceil x \\rceil", "Ceiling"],
      ["[x]", "Greatest integer (box)"],
      ["\\{x\\}", "Fractional part"],
      ["\\operatorname{sgn}(x)", "Signum function"],
      ["\\max", "Maximum"],
      ["\\min", "Minimum"],
      ["\\sup", "Supremum"],
      ["\\inf", "Infimum"],
      ["\\arg", "Argument"],
      ["\\deg", "Degree"],
      ["\\gcd", "Greatest common divisor"],
      ["\\operatorname{lcm}", "Least common multiple"],
      ["\\operatorname{HCF}", "Highest common factor"],
      ["\\operatorname{LCM}", "LCM"],
      ["\\operatorname{Dom}(f)", "Domain"],
      ["\\operatorname{Range}(f)", "Range"],
      ["\\ker", "Kernel"],
      ["\\dim", "Dimension"],
      ["\\operatorname{f}", "Custom operator name"],
    ],
  },
  {
    title: "Vectors",
    symbols: [
      ["\\vec{a}", "Vector a"],
      ["\\vec{b}", "Vector b"],
      ["\\vec{r}", "Position vector"],
      ["\\overrightarrow{AB}", "Vector AB"],
      ["\\hat{a}", "Unit vector a"],
      ["\\hat{i}", "Unit vector i"],
      ["\\hat{j}", "Unit vector j"],
      ["\\hat{k}", "Unit vector k"],
      ["\\hat{n}", "Unit normal"],
      ["a\\hat{i} + b\\hat{j} + c\\hat{k}", "Vector in components"],
      ["|\\vec{a}|", "Magnitude of vector"],
      ["\\vec{a} \\cdot \\vec{b}", "Dot product"],
      ["\\vec{a} \\times \\vec{b}", "Cross product"],
      ["\\vec{a} \\cdot \\vec{b} = |\\vec{a}||\\vec{b}|\\cos\\theta", "Dot product formula"],
      ["|\\vec{a} \\times \\vec{b}| = |\\vec{a}||\\vec{b}|\\sin\\theta", "Cross product magnitude"],
      ["[\\vec{a}\\ \\vec{b}\\ \\vec{c}]", "Scalar triple product"],
      ["\\vec{a} \\cdot (\\vec{b} \\times \\vec{c})", "Scalar triple product (expanded)"],
      ["\\vec{a} \\times (\\vec{b} \\times \\vec{c})", "Vector triple product"],
      ["\\vec{0}", "Zero vector"],
      ["\\mathbf{v}", "Bold vector"],
      ["\\begin{vmatrix} \\hat{i} & \\hat{j} & \\hat{k} \\\\ a_{1} & a_{2} & a_{3} \\\\ b_{1} & b_{2} & b_{3} \\end{vmatrix}", "Cross product determinant"],
      ["\\frac{\\vec{a} \\cdot \\vec{b}}{|\\vec{b}|}", "Projection of a on b"],
    ],
  },
  {
    title: "Matrices & determinants",
    symbols: [
      ["\\begin{bmatrix} a & b \\\\ c & d \\end{bmatrix}", "2×2 matrix (square brackets)"],
      ["\\begin{pmatrix} a & b \\\\ c & d \\end{pmatrix}", "2×2 matrix (round brackets)"],
      ["\\begin{bmatrix} a_{11} & a_{12} & a_{13} \\\\ a_{21} & a_{22} & a_{23} \\\\ a_{31} & a_{32} & a_{33} \\end{bmatrix}", "3×3 matrix"],
      ["\\begin{vmatrix} a & b \\\\ c & d \\end{vmatrix}", "2×2 determinant"],
      ["\\begin{vmatrix} a_{1} & b_{1} & c_{1} \\\\ a_{2} & b_{2} & c_{2} \\\\ a_{3} & b_{3} & c_{3} \\end{vmatrix}", "3×3 determinant"],
      ["\\begin{bmatrix} x \\\\ y \\\\ z \\end{bmatrix}", "Column matrix"],
      ["\\begin{bmatrix} x & y & z \\end{bmatrix}", "Row matrix"],
      ["\\begin{matrix} a & b \\\\ c & d \\end{matrix}", "Matrix (no brackets)"],
      ["\\begin{Vmatrix} a & b \\\\ c & d \\end{Vmatrix}", "Matrix norm"],
      ["\\begin{bmatrix} 1 & 0 \\\\ 0 & 1 \\end{bmatrix}", "Identity matrix 2×2"],
      ["\\begin{bmatrix} a_{11} & \\cdots & a_{1n} \\\\ \\vdots & \\ddots & \\vdots \\\\ a_{m1} & \\cdots & a_{mn} \\end{bmatrix}", "m×n matrix"],
      ["A^{T}", "Transpose"],
      ["A'", "Transpose (prime)"],
      ["A^{-1}", "Inverse matrix"],
      ["\\operatorname{adj} A", "Adjoint"],
      ["A^{-1} = \\frac{1}{|A|}\\operatorname{adj} A", "Inverse formula"],
      ["|A|", "Determinant of A"],
      ["\\det(A)", "Determinant (det)"],
      ["\\operatorname{tr}(A)", "Trace"],
      ["\\operatorname{rank}(A)", "Rank"],
      ["I_{n}", "Identity matrix n"],
      ["O", "Zero matrix"],
      ["a_{ij}", "Element a_ij"],
      ["[a_{ij}]_{m \\times n}", "Matrix of order m×n"],
      ["C_{ij}", "Cofactor"],
      ["M_{ij}", "Minor"],
      ["AX = B", "Matrix equation"],
    ],
  },
  {
    title: "Sets",
    symbols: [
      ["\\in", "Element of"],
      ["\\notin", "Not an element of"],
      ["\\ni", "Contains as element"],
      ["\\subset", "Proper subset"],
      ["\\supset", "Proper superset"],
      ["\\subseteq", "Subset or equal"],
      ["\\supseteq", "Superset or equal"],
      ["\\nsubseteq", "Not a subset"],
      ["\\subsetneq", "Strict subset"],
      ["\\cup", "Union"],
      ["\\cap", "Intersection"],
      ["\\setminus", "Set difference"],
      ["A - B", "Set difference (minus)"],
      ["A'", "Complement (prime)"],
      ["A^{c}", "Complement"],
      ["\\overline{A}", "Complement (bar)"],
      ["A \\triangle B", "Symmetric difference"],
      ["A \\times B", "Cartesian product"],
      ["\\emptyset", "Empty set"],
      ["\\varnothing", "Empty set (variant)"],
      ["\\phi", "Empty set (phi)"],
      ["\\{\\,\\}", "Set braces"],
      ["\\{x : x > 0\\}", "Set-builder notation"],
      ["\\{x \\mid x > 0\\}", "Set-builder (bar)"],
      ["n(A)", "Cardinality n(A)"],
      ["|A|", "Cardinality |A|"],
      ["P(A)", "Power set"],
      ["n(A \\cup B) = n(A) + n(B) - n(A \\cap B)", "Inclusion–exclusion"],
      ["\\mathbb{N}", "Natural numbers"],
      ["\\mathbb{W}", "Whole numbers"],
      ["\\mathbb{Z}", "Integers"],
      ["\\mathbb{Q}", "Rational numbers"],
      ["\\mathbb{R}", "Real numbers"],
      ["\\mathbb{C}", "Complex numbers"],
      ["\\mathbb{P}", "Prime numbers"],
      ["\\mathbb{R}^{+}", "Positive reals"],
      ["\\mathbb{R} - \\{0\\}", "Non-zero reals"],
      ["\\mathbb{Q}^{c}", "Irrational numbers"],
      ["(a, b)", "Open interval"],
      ["[a, b]", "Closed interval"],
      ["[a, b)", "Half-open interval"],
      ["(-\\infty, \\infty)", "All reals interval"],
      ["\\aleph_{0}", "Aleph null"],
    ],
  },
  {
    title: "Relations & logic",
    symbols: [
      ["\\land", "Logical and"],
      ["\\lor", "Logical or"],
      ["\\neg", "Logical not"],
      ["\\sim p", "Negation (tilde)"],
      ["\\oplus", "Exclusive or"],
      ["\\Rightarrow", "Implies"],
      ["\\Leftarrow", "Implied by"],
      ["\\Leftrightarrow", "If and only if"],
      ["\\to", "Conditional (arrow)"],
      ["\\leftrightarrow", "Biconditional"],
      ["\\forall", "For all"],
      ["\\exists", "There exists"],
      ["\\nexists", "There does not exist"],
      ["\\exists!", "There exists unique"],
      ["\\therefore", "Therefore"],
      ["\\because", "Because"],
      ["\\top", "True / tautology"],
      ["\\bot", "False / contradiction"],
      ["\\vdash", "Proves"],
      ["\\models", "Models / entails"],
      ["\\text{iff}", "Iff (text)"],
      ["R \\subseteq A \\times B", "Relation"],
      ["(a, b) \\in R", "Ordered pair in relation"],
      ["aRb", "a related to b"],
      ["R^{-1}", "Inverse relation"],
      ["\\equiv \\pmod{n}", "Congruent modulo n"],
    ],
  },
  {
    title: "Complex numbers",
    symbols: [
      ["i", "Imaginary unit"],
      ["i^{2} = -1", "i squared"],
      ["\\iota", "Iota (imaginary unit)"],
      ["z = x + iy", "Complex number"],
      ["z = a + ib", "Complex number (a + ib)"],
      ["\\bar{z}", "Conjugate"],
      ["\\overline{z}", "Conjugate (long bar)"],
      ["|z|", "Modulus"],
      ["|z| = \\sqrt{x^{2}+y^{2}}", "Modulus formula"],
      ["\\arg(z)", "Argument"],
      ["\\operatorname{Arg}(z)", "Principal argument"],
      ["\\operatorname{Re}(z)", "Real part"],
      ["\\operatorname{Im}(z)", "Imaginary part"],
      ["\\Re", "Real part (symbol)"],
      ["\\Im", "Imaginary part (symbol)"],
      ["z = r(\\cos\\theta + i\\sin\\theta)", "Polar form"],
      ["re^{i\\theta}", "Euler form"],
      ["e^{i\\theta} = \\cos\\theta + i\\sin\\theta", "Euler's formula"],
      ["\\operatorname{cis}\\theta", "cis theta"],
      ["(\\cos\\theta + i\\sin\\theta)^{n} = \\cos n\\theta + i\\sin n\\theta", "De Moivre's theorem"],
      ["\\omega", "Cube root of unity"],
      ["\\omega^{2}", "Omega squared"],
      ["1 + \\omega + \\omega^{2} = 0", "Cube roots of unity sum"],
      ["\\omega^{3} = 1", "Omega cubed"],
      ["z\\bar{z} = |z|^{2}", "z times conjugate"],
    ],
  },
  {
    title: "Permutations, combinations & probability",
    symbols: [
      ["n!", "Factorial"],
      ["{}^{n}P_{r}", "Permutations nPr"],
      ["{}^{n}C_{r}", "Combinations nCr"],
      ["\\binom{n}{r}", "Binomial coefficient"],
      ["{}^{n}P_{r} = \\frac{n!}{(n-r)!}", "nPr formula"],
      ["{}^{n}C_{r} = \\frac{n!}{r!(n-r)!}", "nCr formula"],
      ["\\frac{n!}{p!\\,q!\\,r!}", "Permutations with repetition"],
      ["(n-1)!", "Circular permutations"],
      ["P(A)", "Probability of A"],
      ["P(\\bar{A})", "Probability of not A"],
      ["P(A')", "Probability of complement"],
      ["P(A \\cap B)", "Probability of A and B"],
      ["P(A \\cup B)", "Probability of A or B"],
      ["P(A \\mid B)", "Conditional probability"],
      ["P(A \\mid B) = \\frac{P(A \\cap B)}{P(B)}", "Conditional probability formula"],
      ["P(A \\cup B) = P(A) + P(B) - P(A \\cap B)", "Addition rule"],
      ["P(A_{i} \\mid B) = \\frac{P(A_{i})P(B \\mid A_{i})}{\\sum_{j} P(A_{j})P(B \\mid A_{j})}", "Bayes' theorem"],
      ["P(X = r) = \\binom{n}{r} p^{r} q^{n-r}", "Binomial distribution"],
      ["E(X)", "Expected value"],
      ["E(X) = \\sum x_{i}p_{i}", "Expectation formula"],
      ["\\operatorname{Var}(X)", "Variance"],
      ["\\operatorname{Var}(X) = E(X^{2}) - [E(X)]^{2}", "Variance formula"],
      ["np", "Binomial mean"],
      ["npq", "Binomial variance"],
      ["S", "Sample space"],
    ],
  },
  {
    title: "Statistics",
    symbols: [
      ["\\bar{x}", "Mean (x bar)"],
      ["\\bar{x} = \\frac{\\sum x_{i}}{n}", "Mean formula"],
      ["\\bar{x} = \\frac{\\sum f_{i}x_{i}}{\\sum f_{i}}", "Mean of grouped data"],
      ["\\mu", "Population mean"],
      ["\\sigma", "Standard deviation"],
      ["\\sigma^{2}", "Variance"],
      ["\\sigma = \\sqrt{\\frac{\\sum (x_{i} - \\bar{x})^{2}}{n}}", "Standard deviation formula"],
      ["\\sigma^{2} = \\frac{\\sum x_{i}^{2}}{n} - \\bar{x}^{2}", "Variance shortcut"],
      ["\\text{M.D.}", "Mean deviation"],
      ["\\frac{\\sum |x_{i} - \\bar{x}|}{n}", "Mean deviation formula"],
      ["\\text{Median} = l + \\frac{\\frac{N}{2} - cf}{f} \\times h", "Median (grouped)"],
      ["\\text{Mode} = l + \\frac{f_{1} - f_{0}}{2f_{1} - f_{0} - f_{2}} \\times h", "Mode (grouped)"],
      ["\\text{C.V.} = \\frac{\\sigma}{\\bar{x}} \\times 100", "Coefficient of variation"],
      ["\\hat{x}", "Estimate (hat)"],
      ["\\tilde{x}", "Median (tilde)"],
      ["f_{i}", "Frequency"],
      ["\\sum f_{i}", "Total frequency"],
      ["\\chi^{2}", "Chi-squared"],
      ["r", "Correlation coefficient"],
    ],
  },
  {
    title: "Coordinate geometry & conics",
    symbols: [
      ["(x, y)", "Point"],
      ["(x_{1}, y_{1})", "Point 1"],
      ["(x_{2}, y_{2})", "Point 2"],
      ["(x, y, z)", "Point in 3D"],
      ["\\sqrt{(x_{2}-x_{1})^{2} + (y_{2}-y_{1})^{2}}", "Distance formula"],
      ["\\left(\\frac{x_{1}+x_{2}}{2}, \\frac{y_{1}+y_{2}}{2}\\right)", "Midpoint"],
      ["\\left(\\frac{mx_{2}+nx_{1}}{m+n}, \\frac{my_{2}+ny_{1}}{m+n}\\right)", "Section formula"],
      ["m = \\frac{y_{2}-y_{1}}{x_{2}-x_{1}}", "Slope"],
      ["m = \\tan\\theta", "Slope from angle"],
      ["y = mx + c", "Slope-intercept form"],
      ["y - y_{1} = m(x - x_{1})", "Point-slope form"],
      ["\\frac{x}{a} + \\frac{y}{b} = 1", "Intercept form"],
      ["ax + by + c = 0", "General line"],
      ["\\frac{|ax_{1} + by_{1} + c|}{\\sqrt{a^{2}+b^{2}}}", "Distance of point from line"],
      ["\\tan\\theta = \\left|\\frac{m_{1}-m_{2}}{1+m_{1}m_{2}}\\right|", "Angle between lines"],
      ["\\frac{1}{2}\\begin{vmatrix} x_{1} & y_{1} & 1 \\\\ x_{2} & y_{2} & 1 \\\\ x_{3} & y_{3} & 1 \\end{vmatrix}", "Area of triangle"],
      ["x^{2} + y^{2} = r^{2}", "Circle (centre origin)"],
      ["(x-h)^{2} + (y-k)^{2} = r^{2}", "Circle (centre h,k)"],
      ["x^{2} + y^{2} + 2gx + 2fy + c = 0", "General circle"],
      ["y^{2} = 4ax", "Parabola"],
      ["x^{2} = 4ay", "Parabola (vertical)"],
      ["\\frac{x^{2}}{a^{2}} + \\frac{y^{2}}{b^{2}} = 1", "Ellipse"],
      ["\\frac{x^{2}}{a^{2}} - \\frac{y^{2}}{b^{2}} = 1", "Hyperbola"],
      ["xy = c^{2}", "Rectangular hyperbola"],
      ["b^{2} = a^{2}(1 - e^{2})", "Ellipse eccentricity"],
      ["b^{2} = a^{2}(e^{2} - 1)", "Hyperbola eccentricity"],
      ["\\frac{x - x_{1}}{a} = \\frac{y - y_{1}}{b} = \\frac{z - z_{1}}{c}", "Line in 3D"],
      ["\\vec{r} = \\vec{a} + \\lambda\\vec{b}", "Vector line"],
      ["\\vec{r} \\cdot \\hat{n} = d", "Vector plane"],
      ["l^{2} + m^{2} + n^{2} = 1", "Direction cosines"],
    ],
  },
  {
    title: "Geometry",
    symbols: [
      ["\\angle", "Angle"],
      ["\\angle ABC", "Angle ABC"],
      ["\\measuredangle", "Measured angle"],
      ["\\triangle", "Triangle"],
      ["\\triangle ABC", "Triangle ABC"],
      ["\\square", "Square"],
      ["\\square ABCD", "Quadrilateral ABCD"],
      ["\\odot", "Circle (symbol)"],
      ["\\bigcirc", "Big circle"],
      ["\\overline{AB}", "Line segment AB"],
      ["\\overleftrightarrow{AB}", "Line AB"],
      ["\\overrightarrow{AB}", "Ray AB"],
      ["\\overset{\\frown}{AB}", "Arc AB"],
      ["AB \\parallel CD", "Parallel lines"],
      ["AB \\perp CD", "Perpendicular lines"],
      ["\\cong", "Congruent"],
      ["\\sim", "Similar"],
      ["\\triangle ABC \\sim \\triangle PQR", "Similar triangles"],
      ["\\triangle ABC \\cong \\triangle PQR", "Congruent triangles"],
      ["^{\\circ}", "Degree"],
      ["90^{\\circ}", "Right angle 90°"],
      ["180^{\\circ}", "Straight angle 180°"],
      ["'", "Minute (angle)"],
      ["''", "Second (angle)"],
      ["\\pi r^{2}", "Area of circle"],
      ["2\\pi r", "Circumference"],
      ["\\frac{1}{2}bh", "Area of triangle"],
      ["\\sqrt{s(s-a)(s-b)(s-c)}", "Heron's formula"],
      ["\\frac{4}{3}\\pi r^{3}", "Volume of sphere"],
      ["4\\pi r^{2}", "Surface area of sphere"],
      ["\\pi r^{2}h", "Volume of cylinder"],
      ["\\frac{1}{3}\\pi r^{2}h", "Volume of cone"],
      ["a^{2} + b^{2} = c^{2}", "Pythagoras theorem"],
    ],
  },
  {
    title: "Arrows",
    symbols: [
      ["\\rightarrow", "Right arrow"],
      ["\\leftarrow", "Left arrow"],
      ["\\leftrightarrow", "Left-right arrow"],
      ["\\longrightarrow", "Long right arrow"],
      ["\\longleftarrow", "Long left arrow"],
      ["\\Rightarrow", "Double right arrow"],
      ["\\Leftarrow", "Double left arrow"],
      ["\\Leftrightarrow", "Double left-right arrow"],
      ["\\Longrightarrow", "Long double right arrow"],
      ["\\Longleftrightarrow", "Long double left-right"],
      ["\\uparrow", "Up arrow"],
      ["\\downarrow", "Down arrow"],
      ["\\updownarrow", "Up-down arrow"],
      ["\\Uparrow", "Double up arrow"],
      ["\\Downarrow", "Double down arrow"],
      ["\\nearrow", "North-east arrow"],
      ["\\searrow", "South-east arrow"],
      ["\\swarrow", "South-west arrow"],
      ["\\nwarrow", "North-west arrow"],
      ["\\mapsto", "Maps to"],
      ["\\longmapsto", "Long maps to"],
      ["\\hookrightarrow", "Hook right arrow"],
      ["\\hookleftarrow", "Hook left arrow"],
      ["\\rightharpoonup", "Right harpoon"],
      ["\\rightleftharpoons", "Equilibrium harpoons"],
      ["\\circlearrowleft", "Anticlockwise arrow"],
      ["\\circlearrowright", "Clockwise arrow"],
      ["\\xrightarrow{\\text{text}}", "Arrow with text above"],
      ["\\xleftarrow{\\text{text}}", "Left arrow with text"],
      ["\\xrightarrow[\\text{below}]{\\text{above}}", "Arrow with text above and below"],
    ],
  },
  {
    title: "Brackets & delimiters",
    symbols: [
      ["()", "Parentheses"],
      ["[]", "Square brackets"],
      ["\\{\\}", "Braces"],
      ["\\langle \\rangle", "Angle brackets"],
      ["|x|", "Absolute value"],
      ["\\|x\\|", "Norm"],
      ["\\lfloor x \\rfloor", "Floor"],
      ["\\lceil x \\rceil", "Ceiling"],
      ["\\left( \\frac{a}{b} \\right)", "Auto-sized parentheses"],
      ["\\left[ \\frac{a}{b} \\right]", "Auto-sized brackets"],
      ["\\left\\{ \\frac{a}{b} \\right\\}", "Auto-sized braces"],
      ["\\left| \\frac{a}{b} \\right|", "Auto-sized bars"],
      ["\\big(", "Big parenthesis"],
      ["\\Big(", "Bigger parenthesis"],
      ["\\bigg(", "Biggest parenthesis"],
      ["\\underbrace{a + b}_{\\text{text}}", "Underbrace with label"],
      ["\\overbrace{a + b}^{\\text{text}}", "Overbrace with label"],
    ],
  },
  {
    title: "Accents & styles",
    symbols: [
      ["\\bar{x}", "Bar"],
      ["\\overline{AB}", "Long bar (overline)"],
      ["\\underline{x}", "Underline"],
      ["\\hat{x}", "Hat"],
      ["\\widehat{AB}", "Wide hat"],
      ["\\tilde{x}", "Tilde"],
      ["\\widetilde{AB}", "Wide tilde"],
      ["\\vec{x}", "Vector arrow"],
      ["\\dot{x}", "Dot"],
      ["\\ddot{x}", "Double dot"],
      ["\\acute{x}", "Acute"],
      ["\\grave{x}", "Grave"],
      ["\\breve{x}", "Breve"],
      ["\\check{x}", "Check"],
      ["\\mathring{A}", "Ring"],
      ["x'", "Prime"],
      ["x''", "Double prime"],
      ["\\mathbf{x}", "Bold"],
      ["\\boldsymbol{\\alpha}", "Bold Greek"],
      ["\\mathit{x}", "Italic"],
      ["\\mathrm{x}", "Upright (roman)"],
      ["\\mathbb{R}", "Blackboard bold"],
      ["\\mathcal{L}", "Calligraphic"],
      ["\\mathscr{L}", "Script"],
      ["\\mathfrak{g}", "Fraktur"],
      ["\\mathsf{x}", "Sans-serif"],
      ["\\mathtt{x}", "Typewriter"],
      ["\\text{text}", "Text inside maths"],
      ["\\textbf{text}", "Bold text"],
      ["\\color{red}{x}", "Coloured text"],
      ["\\boxed{x}", "Boxed answer"],
      ["\\cancel{x}", "Cancel (strike)"],
      ["\\bcancel{x}", "Back-cancel"],
      ["\\xcancel{x}", "Cross out"],
    ],
  },
  {
    title: "Layout & spacing",
    symbols: [
      ["\\begin{cases} x, & x \\geq 0 \\\\ -x, & x < 0 \\end{cases}", "Piecewise function"],
      ["\\begin{aligned} a &= b + c \\\\ &= d \\end{aligned}", "Aligned equations"],
      ["\\begin{array}{c|c} a & b \\\\ \\hline c & d \\end{array}", "Table / array"],
      ["\\left\\{ \\begin{array}{l} x + y = 1 \\\\ x - y = 3 \\end{array} \\right.", "System of equations"],
      ["\\overset{\\text{top}}{=}", "Text over symbol"],
      ["\\underset{\\text{below}}{=}", "Text under symbol"],
      ["\\stackrel{\\text{def}}{=}", "Stacked relation"],
      ["\\\\", "New line"],
      ["\\,", "Thin space"],
      ["\\;", "Medium space"],
      ["\\quad", "Wide space"],
      ["\\qquad", "Double wide space"],
      ["\\!", "Negative space"],
      ["\\displaystyle", "Display style (full size)"],
    ],
  },
  {
    title: "Dots & miscellaneous",
    symbols: [
      ["\\dots", "Ellipsis"],
      ["\\cdots", "Centred dots"],
      ["\\ldots", "Low dots"],
      ["\\vdots", "Vertical dots"],
      ["\\ddots", "Diagonal dots"],
      ["\\infty", "Infinity"],
      ["-\\infty", "Minus infinity"],
      ["\\aleph", "Aleph"],
      ["\\hbar", "h-bar"],
      ["\\ell", "Script l"],
      ["\\wp", "Weierstrass p"],
      ["\\prime", "Prime"],
      ["\\backslash", "Backslash"],
      ["\\dagger", "Dagger"],
      ["\\ddagger", "Double dagger"],
      ["\\S", "Section sign"],
      ["\\checkmark", "Check mark"],
      ["\\blacksquare", "End of proof (QED)"],
      ["\\square", "Empty square"],
      ["\\diamond", "Diamond"],
      ["\\clubsuit", "Club suit"],
      ["\\diamondsuit", "Diamond suit"],
      ["\\heartsuit", "Heart suit"],
      ["\\spadesuit", "Spade suit"],
      ["\\sharp", "Sharp"],
      ["\\flat", "Flat"],
    ],
  },
];

export default mathSymbols;
